import pedidoCertidaoInteiroTeor from './pedidoCertidaoInteiroTeor/config';
import pedidoCertidaoInteiroTeorTransferencia from './pedidoCertidaoInteiroTeorTransferencia/config';
import pedidoCertidaoInteiroTeorSociedade from './pedidoCertidaoInteiroTeorSociedade/config';
import pedidoCertidaoInteiroTeorSuplementar from './pedidoCertidaoInteiroTeorSuplementar/config';
import pedidoCertidaoNaoInscrito from './pedidoCertidaoNaoInscrito/config';

export const pedido_certidao_inteiro_teor = pedidoCertidaoInteiroTeor;
export const pedido_certidao_inteiro_teor_transferencia = pedidoCertidaoInteiroTeorTransferencia;
export const pedido_certidao_inteiro_teor_sociedade = pedidoCertidaoInteiroTeorSociedade;
export const pedido_certidao_inteiro_teor_suplementar = pedidoCertidaoInteiroTeorSuplementar;
export const pedido_certidao_nao_inscrito = pedidoCertidaoNaoInscrito;
